// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"127":"gamelist","465":"crosscase"}[chunkId] || chunkId) + "." + {"127":"fd4ff15f","465":"24702de2","471":"86b4faa2","497":"4ffc113b"}[chunkId] + ".js";
};